// extracted by mini-css-extract-plugin
export default {"host":"style_host__1Le+d","text":"style_text__Mship","clamped":"style_clamped__+RprC","toggle":"style_toggle__-Oo1G"};